function resetElementHeight(el) {
  el.style.minHeight = ''
  el.style.height = 'auto'
}

export {resetElementHeight}